
export default [
    {
        path: '/dataList/inventory/inventoryCheck',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '库存盘点',
            keepAlive: false
        }
    },
];
  